import { Typography } from '@mui/material'
import { Product } from '../../SwapOrReturnTypes'
import { useMemo } from 'react'
import { limitCharacters } from 'src/utils/formatString'
import TableMui from 'src/components/TableMui'
import * as S from './AvailableProductsTable.styles'

interface AvailableProductsTableProps {
  availableProducts: Product[]
  searchTerm: string
  allProductsSelected: boolean
  readOnly: boolean
  onSelect: (product: Product) => void
}

const AvailableProductsTable: React.FC<AvailableProductsTableProps> = ({
  availableProducts, searchTerm, allProductsSelected, readOnly, onSelect,
}) => {
  const filteredAvailableProducts = availableProducts.filter((product) =>
    product.productCode.includes(searchTerm) || product.description.toLowerCase().includes(searchTerm.toLowerCase()))

  const resolveTableRows = useMemo(() => filteredAvailableProducts.map((product) => ({
    ...product,
    description: (
      <S.CustomTooltip arrow title={product.description}>
        <Typography fontSize={14}>
          {limitCharacters(product.description, 22)}
        </Typography>
      </S.CustomTooltip>
    ),
    action: (
      <S.CustomButton
        title='Adicionar'
        bgColor='lightBlue5'
        hoverColor='darkBlueHover2'
        letterColor='white'
        data-testid='add-product-button-test-id'
        disabled={readOnly}
        onClick={() => onSelect(product)}
      />
    ),
  })), [onSelect, filteredAvailableProducts, readOnly])

  return (
    <S.Container>
      <Typography variant='h5' fontWeight='bold'>Produtos disponíveis</Typography>
      <TableMui
        columns={[
          { id: 'productCode', label: 'Cód. produto' },
          { id: 'description', label: 'Desc. produto' },
          { id: 'action', label: 'Ação' },
        ]}
        emptyLabel={
          availableProducts.length === 0 && !allProductsSelected ? 'Bipe a chave da nota fiscal para iniciar a busca por produtos disponíveis'
            : allProductsSelected ? 'Todos os produtos já foram selecionados' : 'Nenhum produto encontrado'
        }
        rows={resolveTableRows}
        enablePagination
        rowsPerPageLimit={10}
        maxHeight='60vh'
        minHeight='60vh'
        testId='available-products-table-test-id'
      />
    </S.Container>
  )
}

export default AvailableProductsTable
